import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import 'rxjs/add/observable/merge';
import { filter, first, map, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';

import { TranslateService } from '@ngx-translate/core';

import { environment } from '@env/environment';
import { I18nService, Logger } from '@app/core';

const log = new Logger('App');
declare var gtag: any;

@Component({
  selector: 'iw-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translateService: TranslateService,
    private i18nService: I18nService) { 
      if(environment.googleAnalyticsId != '') {
        this.appendGaTrackingCode();
        const navEndEvents$ = this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd)
        );
        navEndEvents$.subscribe((event: NavigationEnd) => {
          gtag('config', environment.googleAnalyticsId, {
            'page_path': event.urlAfterRedirects
          });
        });
      }
    }

  ngOnInit() {
    // Setup logger
    if (environment.production) {
      Logger.enableProductionMode();
    }

    // Setup translations
    this.i18nService.init(environment.defaultLanguage, environment.supportedLanguages);

    const onNavigationEnd = this.router.events.filter(event => event instanceof NavigationEnd);

    // Cambiar el título de la página segun el idioma
    Observable.merge(this.translateService.onLangChange, onNavigationEnd)
      .map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      })
      .filter(route => route.outlet === 'primary')
      .mergeMap(route => route.data)
      .subscribe(event => {
        const title = event['title'];
        if (title) {
          this.titleService.setTitle(this.translateService.instant(title));
        }
      });
  }

  private appendGaTrackingCode() {
    try {
      const scriptGTAG = document.createElement('script');
      scriptGTAG.src = 'https://www.googletagmanager.com/gtag/js?id='+environment.googleAnalyticsId;
      scriptGTAG.async = true;
      document.head.appendChild(scriptGTAG);

      const script = document.createElement('script');
      script.innerHTML = `
      window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '`+environment.googleAnalyticsId+`');
      `;
      document.head.appendChild(script);
    } catch (ex) {
     console.error('Error appending google analytics');
     console.error(ex);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts